import { render } from "./Form.vue?vue&type=template&id=f9f45fea&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=f9f45fea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9f45fea"

export default script